export default {
	id: 'SIMPLE_WORKBOOK_BUNDLE_35_V2',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_bundle_35_v2_usd',
		},
		primer: 'prd_phBfmr8aVwYe',
	},
	otp: {
		priceMap: {
			USD: 35,
		},
	},
}
